import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import {
  Card,
  CardBody,
  CardTitle,
  CardText,
  Badge,
  Row,
  Col,
} from "reactstrap";

interface InterfacesharedList {
  sharedList: any[];
}
function SharedUsersList({ sharedList }: InterfacesharedList) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const cancleBtnClick = () => setIsModalOpen(false);
  const toggleRequestModel = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <div>
      <button
        className="btn btn-dark btn-sm"
        onClick={() => setIsModalOpen(true)}
        disabled={sharedList?.length === 0}
      >
        Shared User ({sharedList?.length || 0})
      </button>
      <Modal
        isOpen={isModalOpen}
        className="modal-xl"
        style={{
          backgroundColor: "#F7F7FA",
          borderRadius: "12px",
          padding: "0px",
        }}
        role="dialog"
        autoFocus={true}
        toggle={toggleRequestModel}
      >
        <div className="modal-header justify-content-between">
          <div className="d-flex flex-column align-items-center">
            <h5
              className="modal-title"
              id="staticBackdropLabel"
              style={{ textAlign: "center" }}
            >
              Shared User List ({sharedList?.length || 0})
            </h5>
          </div>

          <button
            className="btn p-0 d-flex align-items-center"
            style={{
              border: "none",
            }}
            onClick={cancleBtnClick}
            title="Close"
          >
            <box-icon name="x" size="30px"></box-icon>
          </button>
        </div>

        <ModalBody style={{ padding: "12px", backgroundColor: "#F7F7FA" }}>
          <Row>
            {sharedList.map((user, index) => (
              // <CardUser data={sharedList} />
              <Col sm="12" md="6" key={index} className="">
                <CardUser data={user} />
              </Col>
            ))}
          </Row>
        </ModalBody>

        <ModalFooter
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <button
            className="btn btn-outline-secondary"
            onClick={cancleBtnClick}
            style={{ marginLeft: "auto" }}
          >
            Cancel
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default SharedUsersList;

export const customStyles: any = {
  subHeader: {
    style: {
      padding: "0px",
      margin: "0px",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#EFF2F7",
      fontWeight: "600",
      fontSize: "11px",
      borderBottom: "none",
    },
  },
  rows: {
    style: {
      fontSize: "11px",
      color: "#343a40",
      borderBottom: "none",
    },
  },
  cells: {
    style: {
      fontSize: "11px",
      color: "#343a40",
      borderBottom: "none",
    },
  },
};

export const CardUser = ({ data }: { data: any }) => {
  const [showTable, setShowTable] = useState<string | null>(null);

  const columns: any[] = [
    {
      name: "Slave",
      selector: (row: any) => row.slave || "-",
      sortable: true,
      wrap: true,
      width: "130px", // fixed width
    },
    {
      name: "Model",
      selector: (row: any) => row.modelType || "-",
      width: "80px",
      wrap: true,
    },
    {
      name: "Product",
      selector: (row: any) => row.product || "-",
      width: "80px",
      wrap: true,
    },
    {
      name: "HW-V",
      selector: (row: any) => row.hwVersion || "-",
      // sortable: true,
      width: "70px",
      wrap: true,
    },
    {
      name: "WI-V",
      selector: (row: any) => row.wifiVersion || "-",
      // sortable: true,
      width: "70px",
      wrap: true,
    },
    {
      name: "Signal",
      selector: (row: any) => row.signalStrength ?? "-",
      // sortable: true,
      width: "70px",
      wrap: true,
    },
  ];

  return (
    <Card className="shadow-sm">
      <CardBody>
        <Row>
          <Col className="">
            <CardTitle tag="h5">
              <a
                href={`/users/profile/${data?.sharedUserId}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {data?.firstname} {data?.lastname}
              </a>
              {data?.isActive && (
                <Badge color="success" className="ms-2 px-1 py-1 fs-7">
                  Active
                </Badge>
              )}
            </CardTitle>
            <CardText>
              <strong>Mobile:</strong> {data?.mobile} <br />
              <strong>Email:</strong> {data?.email} <br />
              <strong>Relation:</strong> {data?.relation || "-"}
            </CardText>
          </Col>
          <Col className="">
            <CardText>
              <strong>Rooms:</strong>
              <div className="mt-1 d-flex flex-wrap gap-2">
                {data?.roomNames?.map((room: any, idx: any) => (
                  <Badge color="primary" className="px-1 py-1 fs-7" key={idx}>
                    {room}
                  </Badge>
                ))}
              </div>
            </CardText>
          </Col>
        </Row>
        <Row>
          <Col className="d-flex gap-2 p-2 ">
            <div>
              <button
                type="button"
                className={`btn btn-sm ${
                  showTable === "Chips" ? "btn-dark" : "btn-outline-dark"
                } d-flex justify-content-between align-items-center`}
                onClick={() =>
                  setShowTable((prev) => (prev === "Chips" ? null : "Chips"))
                }
                disabled={data?.chips?.length === 0}
              >
                <span>
                  <strong>Chips ({data?.chips?.length || 0})</strong>
                </span>
              </button>
            </div>
            <div>
              <button
                type="button"
                className="btn btn-sm btn-outline-dark  d-flex justify-content-between align-items-center"
                onClick={() => console.log("Blaster clicked")}
                disabled={true}
              >
                <span>
                  <strong>
                    Blaster(
                    {data?.blasterRemoteDetails?.length || 0})
                  </strong>
                </span>
              </button>
            </div>
          </Col>
        </Row>
        {showTable === "Chips" && (
          <Row>
            <DataTable
              columns={columns}
              data={data?.chips}
              noDataComponent="No records found."
              customStyles={customStyles}
              highlightOnHover
              dense
            />
          </Row>
        )}
      </CardBody>
    </Card>
  );
};
